import { GalaxyTheme } from "@galaxy-io/dls/theme/enums";
import type { GalaxyProviderStorage } from "@galaxy-io/dls/theme/GalaxyProvider";

export const THEME_COOKIE = "galaxy-theme";
/** Accept the lowercase preference written by DLS 1.x as well as 2.x enums. */
export function themePreference(value: string | undefined): GalaxyTheme {
  const normalized = value?.toUpperCase();
  return normalized === GalaxyTheme.LIGHT || normalized === GalaxyTheme.DARK
    ? normalized
    : GalaxyTheme.SYSTEM;
}
export const themeStorage: GalaxyProviderStorage = {
  get() {
    const value = document.cookie.match(/(?:^|;\s*)galaxy-theme=([^;]+)/)?.[1];
    return value ? themePreference(value) : null;
  },
  set(_key, value) {
    document.cookie = `${THEME_COOKIE}=${value}; Path=/; Max-Age=31536000; SameSite=Lax`;
  },
};
